export default "__VITE_PUBLIC_ASSET__59d513f0__"